// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__xlZI8"};